import { Empty } from "antd";
import BillerCard from "../biller";
import { useTranslation } from "react-i18next";


export default function BillerBeneFiciaryListItem({ dataSource = [] }) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })} />
      ) : (
        <div>
          {dataSource.map((option, index) => (
            <BillerCard record={option} />
          ))}
        </div>
      )}
    </>
  );
}
